export interface Upload {
    file: File;
    state: {
        status: UploadStatus;
        progress: number;
    };
}

export enum UploadStatus {
    UPLOADING = 'UPLOADING',
    PROCESSING = 'PROCESSING',
    UPLOADED = 'UPLOADED',
    CANCELED = 'CANCELED',
    FAILED = 'FAILED'
}
